import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["styles"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.83596 0l2.16371.66872L9.16404 0l1.37646 1.87748 2.1227.7974.0664 2.36824L14 7l-1.2704 1.95688-.0664 2.36822-2.1233.7981L9.16404 14l-2.16437-.6687L4.83596 14l-1.37649-1.8768-2.1227-.7981-.06641-2.36822L0 7l1.27036-1.95688.06641-2.36824 2.12335-.7974L4.83596 0zm3.15399 9.09571L3.88761 4.99337l.67417-.67417 4.10234 4.10234.00337-3.76525.95058-.00001.00001 5.39342H4.2247l-.00337-.95399h3.76862z",
    fill: "currentColor"
  }));
});